export default __webpack_public_path__ + "static/media/serge-kutuzov.02004ac3.jpg";